import { useEffect, useState } from "react"

type FadePresenceOptions = {
  /** duration of the fade-out in ms (must match CSS) */
  duration: number

  /** optional delay before starting fade-out */
  delay?: number
}

/** Utility for fading out UI elements and unmounting once animation has finished */
export function useFadePresence(
  show: boolean,
  options: FadePresenceOptions
) {
  const [ visible, setVisible ] = useState(show)
  const [ opaque, setOpaque ] = useState(show)

  useEffect(() => {
    if (show) {
      setVisible(true)

      requestAnimationFrame(() => {
        setOpaque(true)
      })
      return
    }

    const delayTimeout = setTimeout(() => {
      setOpaque(false)

      const unmountTimeout = setTimeout(() => {
        setVisible(false)
      }, options.duration)

      return () => clearTimeout(unmountTimeout)
    }, options.delay)

    return () => clearTimeout(delayTimeout)
  }, [ show, options.duration, options.delay ])

  return { visible, opaque } as const
}
